/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */

export * from "./operations.js";
export * from "./availabilitySets.js";
export * from "./capacityReservationGroups.js";
export * from "./dedicatedHostGroups.js";
export * from "./images.js";
export * from "./virtualMachineImagesEdgeZone.js";
export * from "./virtualMachineImages.js";
export * from "./logAnalytics.js";
export * from "./virtualMachineExtensionImages.js";
export * from "./virtualMachineRunCommands.js";
export * from "./usageOperations.js";
export * from "./virtualMachineScaleSets.js";
export * from "./virtualMachines.js";
export * from "./virtualMachineSizes.js";
export * from "./proximityPlacementGroups.js";
export * from "./restorePointCollections.js";
export * from "./sshPublicKeys.js";
export * from "./capacityReservations.js";
export * from "./dedicatedHosts.js";
export * from "./restorePoints.js";
export * from "./virtualMachineScaleSetRollingUpgrades.js";
export * from "./virtualMachineScaleSetExtensions.js";
export * from "./virtualMachineScaleSetVMs.js";
export * from "./virtualMachineScaleSetVMExtensions.js";
export * from "./virtualMachineScaleSetVMRunCommands.js";
export * from "./virtualMachineExtensions.js";
export * from "./diskAccesses.js";
export * from "./diskEncryptionSets.js";
export * from "./disks.js";
export * from "./snapshots.js";
export * from "./diskRestorePointOperations.js";
export * from "./resourceSkus.js";
export * from "./galleries.js";
export * from "./communityGalleries.js";
export * from "./communityGalleryImages.js";
export * from "./communityGalleryImageVersions.js";
export * from "./sharedGalleries.js";
export * from "./sharedGalleryImages.js";
export * from "./sharedGalleryImageVersions.js";
export * from "./galleryApplications.js";
export * from "./galleryApplicationVersions.js";
export * from "./galleryImages.js";
export * from "./galleryImageVersions.js";
export * from "./galleryInVMAccessControlProfiles.js";
export * from "./galleryInVMAccessControlProfileVersions.js";
export * from "./gallerySharingProfile.js";
export * from "./softDeletedResource.js";
export * from "./cloudServiceRoleInstances.js";
export * from "./cloudServiceRoles.js";
export * from "./cloudServices.js";
export * from "./cloudServicesUpdateDomain.js";
export * from "./cloudServiceOperatingSystems.js";
